export const geometryToGeoJson = (
  geometry: GeoJSON.Geometry,
): GeoJSON.Feature<GeoJSON.Geometry> => {
  return {
    type: 'Feature',
    properties: {},
    geometry,
  }
}
